import * as mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'

import user from '@/store/shared/user'
import list from '@/store/shared/selectableList'
import search from '@/store/shared/search'

export default{
  namespaced: true,
  state () {
    return {
      username: undefined,
      role: undefined,
      email: undefined,
      active: undefined,
      loaded: false
    }
  },
  mutations,
  actions,
  getters,
  modules: {
    edit: user,
    list,
    search
  }
}
